// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"16":"7c220343","361":"fe039296","461":"791fa99c","785":"4e8b41e5","922":"fc70f09a"}[chunkId] + ".css";
};